const DomainStatus = {
  CHECKING: "CHECKING",
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  PREMIUM: "PREMIUM",
  UNKNOWN: "UNKNOWN",
};

export default Object.freeze(DomainStatus);